import { DataIntegrityLogFormatter, dateTimeFormatter } from "../../gridFormatters";

export const dirColumnDefs = [
  {
    headerName: "",
    field: "title",
    flex: 2,
    filter: "agTextColumnFilter",
    sortable: true
  },
  {
    headerName: "Storage",
    field: "storageDevicesTotal",
    flex: 1,
    cellStyle: {
      textAlign: "right"
    },
    sortable: true
  },
  {
    headerName: "Virtual",
    field: "virtualDevicesTotal",
    flex: 1,
    cellStyle: {
      textAlign: "right"
    },
    sortable: true
  },
  {
    headerName: "Cloud",
    field: "cloudDevicesTotal",
    flex: 1,
    cellStyle: {
      textAlign: "right"
    },
    sortable: true
  },
  {
    headerName: "Switch",
    field: "switchDevicesTotal",
    flex: 1,
    cellStyle: {
      textAlign: "right"
    },
    sortable: true
  },
  {
    headerName: "File",
    field: "fileDevicesTotal",
    flex: 1,
    cellStyle: {
      textAlign: "right"
    },
    sortable: true
  },
  {
    headerName: "Database",
    field: "databaseDevicesTotal",
    flex: 1,
    cellStyle: {
      textAlign: "right"
    },
    sortable: true
  }
];
export const logsDefs = [
  {
    headerName: 'Device Name',
    field: 'deviceName',
    flex: 2,
    filter: 'agTextColumnFilter',
    sortable: true,
  },
  {
    headerName: 'Device Type',
    field: 'deviceTypeCode',
    flex: 1,
    sortable: true,
  },
  {
    headerName: 'Context',
    field: 'context',
    flex: 1,
    sortable: true,
  },
  {
    headerName: 'Upload Date',
    field: 'uploadDate',
    flex: 1,
    sortable: true,
    cellRenderer: dateTimeFormatter,
  },
  {
    headerName: 'Log',
    field: 'log',
    // tooltipField: 'log',
    // tooltipComponentParams: { style: { whiteSpace: 'pre-wrap' } },
    autoHeight: true,
    cellClass: 'ag-cell-wrap-text',
    flex: 3,
    cellRenderer: DataIntegrityLogFormatter
  },
  { field: 'status', hide: true },
  { field: 'collectionDeviceId', hide: true },
];
